<template>
<div :class="is_nested ? 'form-submission-card-content-child-item' : 'form-submission-card-content-child'">
    <response-question :question="question" />
    <response-options :answer="answer" />
    <response-option-free-text
        v-if="answer?.option?.is_free_text"
        :answer="answer.answer"
    />
</div>
</template>

<script>
import ResponseQuestion from "./ResponseQuestion.vue";
import ResponseOptions from "./ResponseOptions.vue";
import ResponseOptionFreeText from "./ResponseOptionFreeText.vue";

export default {
    components: {
        ResponseQuestion,
        ResponseOptions,
        ResponseOptionFreeText,
    },
    props: {
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: Object,
            required: true,
        },
        is_nested: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
